import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai'

function AccordionTwo({ children, open = false, title }) {

    const [isOpen, setIsOpen] = useState(open);

    const handleOpen = () => {
        setIsOpen(!isOpen)
    }

    return (
        <div className='w-full px-3 py-2 pb-4 border-b'>
            {/* Head */}
            <div className="cursor-pointer flex items-center w-full justify-between mb-1" onClick={handleOpen}>
                <h3 className='font-medium text-lg'>{title}</h3>
                <button onClick={handleOpen} className=''>
                    {isOpen ? <AiOutlineMinus size={12} /> : <AiOutlinePlus size={12} />}
                </button>
            </div>
            {/* Body */}

            <motion.div
                className='w-full overflow-hidden'
                animate={{ height: isOpen ? 'auto' : 0, overflow: isOpen ? '' : 'hidden' }}
                exit={{ height: 0 }}
            >
                {children}
            </motion.div>

        </div>
    )
}

export default AccordionTwo